/**
 * Mypawshop – sticky "Köp nu"-rad på mobil.
 * Synkas med bundelväljaren via "mypashow:bundle:selected" och skickar
 * kunden till kassan via cart-permalink (ersätter varukorgen, samma
 * buy-now-semantik som bundelväljarens knapp).
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-mp-sticky-cart]');
  if (!bar) return;

  var priceEl = bar.querySelector('[data-mp-sticky-price]');
  var compareEl = bar.querySelector('[data-mp-sticky-compare]');
  var titleEl = bar.querySelector('[data-mp-sticky-title]');
  var buyBtn = bar.querySelector('[data-mp-sticky-buy]');
  var currentVariantId = bar.getAttribute('data-default-variant-id');

  function formatPrice(cents) {
    if (!cents) return '';
    return (Math.round(cents) / 100).toFixed(0).replace('.', ',') + ' kr';
  }

  document.addEventListener('mypashow:bundle:selected', function (e) {
    var d = e.detail;
    currentVariantId = d.variantId;
    if (titleEl && d.title) titleEl.textContent = d.title;
    if (priceEl && d.price) priceEl.textContent = formatPrice(d.price);
    if (compareEl) {
      if (d.compareAtPrice && Number(d.compareAtPrice) > Number(d.price)) {
        compareEl.textContent = formatPrice(d.compareAtPrice);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
  });

  var heroObserveTarget = document.querySelector('[data-mypashow-hero-observe]');
  if (heroObserveTarget && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(heroObserveTarget);
  } else {
    window.addEventListener(
      'scroll',
      function () {
        bar.classList.toggle('is-visible', window.scrollY > 600);
      },
      { passive: true }
    );
  }

  if (buyBtn) {
    buyBtn.addEventListener('click', function () {
      if (!currentVariantId) return;
      buyBtn.disabled = true;
      buyBtn.textContent = 'Till kassan …';
      window.location.href = '/cart/' + currentVariantId + ':1';
    });
  }
})();
